import { render, staticRenderFns } from "./ToolbarColors.vue?vue&type=template&id=fcbf2532&scoped=true&"
import script from "./ToolbarColors.vue?vue&type=script&lang=js&"
export * from "./ToolbarColors.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarColors.vue?vue&type=style&index=0&id=fcbf2532&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbf2532",
  null
  
)

export default component.exports